module.exports = __webpack_public_path__ + "img/symbol_10.9141ed96.png";